import { Component, inject } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngxs/store';
import { toSignal } from '@angular/core/rxjs-interop';
import { NgIcon } from '@ng-icons/core';
import { AuthSelectors } from '../../../../../shared/store/auth/auth.selectors';
import { AuthFacadeService } from '../../../../../domain/auth/service/auth-facade.service';
import { ApplicationFacadeService } from '../../../../../shared/service/application-facade.service';
import { ApplicationConfig } from '../../../../config/application.config';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-user-menu',
  standalone: true,
  imports: [TranslateModule, NgIcon, BsDropdownModule, RouterLink],
  templateUrl: './user-menu.component.html',
  styleUrl: './user-menu.component.scss',
})
export class UserMenuComponent {
  private store = inject(Store);
  private authFacadeService = inject(AuthFacadeService);
  private applicationFacadeService = inject(ApplicationFacadeService);

  public account = this.store.selectSignal(AuthSelectors.getCurrentLogged);
  public language = toSignal(this.applicationFacadeService.language$);

  public get accountDisplayName(): string {
    const a = this.account();
    if (!a) return '';
    const first = a.firstName?.trim();
    const last = a.lastName?.trim();
    // If both names exist and are different, show full name
    if (first && last && first !== last) {
      return `${first} ${last}`;
    }
    // If same value in both (e.g., email), show once
    if (first && first === last) {
      return first;
    }
    // Fallback to whichever exists, or email
    return first || last || a.email || '';
  }

  public showPolicy(): void {
    const url = this.getUrlWithLang(ApplicationConfig.privacyPolicyUrl);
    window.open(url, '_blank', 'noopener');
  }

  public showTerms(): void {
    const url = this.getUrlWithLang(ApplicationConfig.termsConditionsUrl);
    window.open(url, '_blank', 'noopener');
  }

  public logout(): void {
    this.authFacadeService.logout();
  }

  private getUrlWithLang(url: string): string {
    if (!url) return '#';
    const lang = this.language() ?? ApplicationConfig.defaultLanguage;
    return url.replace('{lang}', lang);
  }
}
